module.exports = __webpack_public_path__ + "img/advocate1.026c05e6.jpg";